// extracted by mini-css-extract-plugin
export default {"container":"StepImage__container___wpETc","img":"StepImage__img___PLS7v"};